import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { VALIDATION_ERROR_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';

const Component = () => import('../../components/property-valuation-page/ValidationError');

const routes: LocalizedRoutes = {
  de: { path: VALIDATION_ERROR_PATH['de'] },
  en: { path: VALIDATION_ERROR_PATH['en'] },
  fr: { path: VALIDATION_ERROR_PATH['fr'] },
  it: { path: VALIDATION_ERROR_PATH['it'] },
};

const localizedRouteConfig = generateLocalizedRouteConfig(
  routes,
  Component,
  `${Pages.Funnel}-validation-error`,
);

export default localizedRouteConfig;
